import { css } from '@emotion/react'
import { Button, HFlow, Modal, ModalBody, ModalFooter, ModalHeader, Text, VFlow } from 'bold-ui'

interface ModalRecusaCadastroProps {
  open: boolean
  onClose(): void
  onConfirm(): void
  isAtualizacao?: boolean
}

export function ModalRecusaCadastro(props: Readonly<ModalRecusaCadastroProps>) {
  const { open, onClose, onConfirm, isAtualizacao = false } = props

  const title = isAtualizacao ? 'Recusa de atualização' : 'Recusa de cadastro'

  return (
    <Modal open={open} onClose={onClose} size='small' closeOnBackdropClick={false}>
      <ModalHeader title={title} icon={{ name: 'infoCircleOutline', fill: 'primary' }} />
      <ModalBody>
        <VFlow vSpacing={1}>
          <Text component='p'>
            {isAtualizacao ? (
              <>
                A recusa de um cidadão perante à atualização cadastral{' '}
                <strong>não implicará no não atendimento deste na unidade de saúde</strong>, bem como quaisquer outras
                formas de discriminação. Sendo assim, esta recusa{' '}
                <strong>não alterará dados do cadastro nem a data da última atualização cadastral</strong>, sendo
                utilizada apenas para contabilização em relatórios.
              </>
            ) : (
              <>
                A recusa de um cidadão ao cadastro{' '}
                <strong>não implicará no não atendimento deste na unidade de saúde</strong>, bem como quaisquer outras
                formas de discriminação. Sendo assim, sua recusa de cadastro só será contabilizada para fins de
                acompanhamento de produção.
              </>
            )}
          </Text>
          <Text component='p'>
            Solicite ao entrevistado que assine o termo de recusa para assegurar que ele está ciente. Em situações em
            que o cidadão se recuse também a assinar o termo, a validação dessa informação deve ser discutida com a
            supervisão e/ou coordenação desta equipe.
          </Text>
        </VFlow>
      </ModalBody>
      <ModalFooter>
        <HFlow justifyContent='flex-end'>
          <Button kind='normal' size='medium' style={styles.button} onClick={onClose}>
            Cancelar
          </Button>
          <Button kind='primary' size='medium' style={styles.button} onClick={onConfirm}>
            Confirmar
          </Button>
        </HFlow>
      </ModalFooter>
    </Modal>
  )
}

const styles = {
  button: css`
    width: 9rem;
  `,
}
